import AdditionalTasksCreateModalComponent from './create-modal.component'

const AdditionalTasksCreateModalModule = angular.module('cdbl.create-modal', [

])
  .component('cdblAdditionalTasksCreateModal', AdditionalTasksCreateModalComponent)
  .name

export default AdditionalTasksCreateModalModule
